<template>
  <div class="detail-info-container">
    <!-- <div class="img-swiper" v-if="targetData.coverPicUrlList">
      <Swipe :autoplay="0" indicator-color="white" class="img-box" ref="swipe">
        <SwipeItem class="img-box" v-for="(img, index) in targetData.coverPicUrlList" :key="img" @click="showPreview(index)">
          <img class="img" :src="`${img}`" />
        </SwipeItem>
      </Swipe>
      <span class="img-num">{{targetData.coverPicList.length}}</span>
    </div>
    <div class="info-box" v-if="targetData.id">
      <div class="name-op-con">
        <span class="name-con"><i class="sex-icon" :class="{female: targetData.sex == 2}"></i><span
            class="nick">{{targetData.nickName}}</span><img class="identify-icon" src="~@/assets/img/identify.png"
            v-if="targetData.identityAuth === 3 && targetData.academicAuth === 3 && targetData.workAuth === 3" /></span>
        <span class="op-con" v-if="mId != targetData.mid">
          <a href="javascript:;" class="report btn" @click="switchReport">举报</a>
          <a href="javascript:;" class="follow btn" :class="{'followed': targetData.follow}"
            @click="switchFollow">{{targetData.follow ? '取消关注' : '关注'}}</a>
        </span>
      </div>
      <div class="id-con" ref="code-con"><strong class="id">ID: {{targetData.mid}}</strong><a href="javascript:;"
          class="copy-btn" @click="execCopy(targetData.mid)">复制</a></div>
      <p class="info-con">
        {{targetData.age}}岁&nbsp;（{{calculater(targetData.birthday.split('-')[0])}}）&nbsp;{{targetData.high}}cm&nbsp;{{constellationMap[targetData.constellation]}}
      </p>

      <p class="info-con">
        {{educationMap[targetData.education]}}
        {{targetData.ifStudent ? '在读' : ''}}{{targetData.school ? `（${targetData.school}）` : ''}}
      </p>
      <template v-if="!targetData.ifStudent">

        <p class="info-con desc">
          公司：{{targetData.companyVisible && targetData.company ? `${targetData.company}` : '保密'}}
          <span class="info-con desc" v-if="!targetData.companyVisible">
            {{targetData.industry ? `(${targetData.industry})` : ''}}
          </span>
        </p>
        <p class="info-con desc">
          职位：{{targetData.job}}
        </p>
      </template>
      <p class="info-con">{{statusMap[targetData.singleStatus]}} {{assetsMap[targetData.richesInfo]}}
        {{targetData.annualSalaryVisible && targetData.annualSalary != 0 ? salaryMap[targetData.annualSalary] : ''}}</p>
      <p class="info-con location">
        {{cityText(targetData)}}
        ·
        {{nativeCityText(targetData)}}
      </p>
    </div>

    <div class="desc-list" v-if="targetData.mid">
      <div class="desc-item">
        <p class="desc-top"><img src="~@/assets/img/self-description.png" alt="" class="self-description" />自我描述</p>
        <p class="desc-detail">{{targetData.selfDescription}}</p>
      </div>
      <div class="desc-item">
        <p class="desc-top"><img src="~@/assets/img/family.png" alt="" class="self-description" />家庭背景</p>
        <p class="desc-detail">{{targetData.familyInfo}}</p>
      </div>
      <div class="desc-item">
        <p class="desc-top"><img src="~@/assets/img/experice.png" alt="" class="self-description" />个人经历</p>
        <p class="desc-detail">{{targetData.personalExperience}}</p>
      </div>
      <div class="desc-item">
        <p class="desc-top"><img src="~@/assets/img/hobby.png" alt="" class="self-description" />兴趣爱好</p>
        <p class="desc-detail">{{targetData.hobby}}</p>
      </div>
      <div class="desc-item">
        <p class="desc-top"><img src="~@/assets/img/love.png" alt="" class="self-description" />爱情观</p>
        <p class="desc-detail">{{targetData.loveMind}}</p>
      </div>
      <div class="desc-item">
        <p class="desc-top"><img src="~@/assets/img/require.png" alt="" class="self-description" />理想的另一半</p>
        <p class="desc-detail">{{targetData.ideaPartner}}</p>
      </div>
    </div> -->

    <user-info :info="targetData" @switchFollow="switchFollow" @switchReport="switchReport"></user-info>

    <div class="btns" v-if="mId != targetData.mid">
      <div class="like-btn btn" :class="{'liked': targetData.like}" @click="clickLike">
        <p class="like word">
          <img v-if="targetData.like" src="~@/assets/img/liked.png" alt="" class="like-icon" />
          <img v-else src="~@/assets/img/like.png" alt="" class="like-icon" />
          {{targetData.like ? '已喜欢TA' : '喜欢ta'}}
        </p>
        <p class="remain-quanitity" v-if="userId">剩余{{userData.likeBalance || 0}}个喜欢名额</p>
      </div>
      <div class="apply-btn btn" :class="{'got': targetData.wechatPicUrl}" @click="getWebChatCode">
        <p class="word"><img src="~@/assets/img/webchat-logo.png" alt=""
            class="apply-icon" />{{targetData.wechatPicUrl ? 'TA的微信' : '索要微信'}}</p>
      </div>
    </div>

    <van-dialog v-model="confirmPurchaseDialog" confirmButtonText="继续支付" :show-cancel-button="true" @confirm="purchase">
      <div class="confirm-purchase-content">
        <h3 class="price-con">
          <p class="cur-price">￥{{transferPrice(purchaseItem.currentPrice)}}<span class="unit">/次</span></p>
          <p class="origin-price">￥{{transferPrice(purchaseItem.originPrice)}}<span class="unit">/次</span></p>
        </h3>
        <ul class="tipsList">
          <ol>1.支付成功后您将获得对方的微信二维码，长按添加对方微信。</ol>
          <ol>2.添加微信时，验证信息请备注：你的ID号学历职业年龄城市</ol>
          <ol>3.本功能只提供微信联系方式，对方是否通过您的好友申请取决于Ta本人，请悉知。</ol>
          <ol>4.费用无法退款，购买有风险，需谨慎！</ol>
        </ul>
      </div>
    </van-dialog>

    <van-dialog v-model="isShowCodeDialog" confirmButtonText="知道了"
      :message="overlimit ? '你的当日索要次数已达上限（每日30次）请明日再来索要' : ''">
      <div class="target-code-dialog" v-if="!overlimit">
        <p class="target-name">{{targetData.nickName}}</p>

        <img :src="targetData.wechatPicUrl" alt="" class="code" />
        <p class="tips">长按识别二维码可添加对方微信<br />
          <template v-if="copyFail">添加对方微信时请在验证信息处备注：<br>您的ID城市工作年龄学历</template>
          <template v-else>您的ID信息已复制，添加对方微信时<br />请粘贴至申请验证信息</template>
        </p>

      </div>
    </van-dialog>

    <van-dialog v-model="showErrorDialog" :message="errorDialogContent.message"
      :confirmButtonText="errorDialogContent.confirmText" :show-cancel-button="true" @confirm="handleErrorDialogClose">
    </van-dialog>

    <!-- 举报弹窗 -->
    <van-popup v-model="isReporting" :close-on-popstate="true" position="right">
      <div class="report-content">
        <div class="title-con">
          <a @click="switchReport" href="javascript:;" class="btn"><img src="~@/assets/img/back-icon.png"
              class="back-icon" /></a>
          <h3 class="title">举报</h3>
        </div>
        <div class="input-cotent">
          <textarea ref="reportInputContent" class="textarea" placeholder="请填写10个字以上的举报问题描述，以便我们核实该用户的不良行为"
            v-model="reportData.description"></textarea>
        </div>
        <div class="upload-box">
          <p class="upload-title">请上传1-3张证据截图</p>
          <div class="upload-content">
            <div class="upload-item" v-for="(img, index) in reportData.imgData" :key="index">
              <img :src="img.url" alt="" class="img-item" />
              <img src="~@/assets/img/close-white.png" alt="" class="delete-btn" @click.stop="deleteImg(index)" />
            </div>
            <div class="upload-item select-item" v-if="reportData.imgData.length < 3">
              <!-- <input type="file" class="upload-input" accept="image/*" ref="file" @change="selectImg" /> -->
              <Oss @fileChange="selectImg" @uploadSucess="uploadSuccess" browse_button="uploadBtn" :actionFile="tempImg"
                :params='coverParams' class="oss-item">
                <div id="uploadBtn">
                  <img src="~@/assets/img/upload-bg.png" class="upload-btn" />
                </div>
              </Oss>
              <img src="~@/assets/img/upload-bg.png" alt="" class="upload-btn" />
            </div>
          </div>
        </div>
        <a href="javascript:;" class="commit-report" :class="{disable: disableReport}" @click="submitReport">确认举报</a>
      </div>
    </van-popup>

    <!-- 加速审核弹窗 -->
    <AccelerateAduit v-model="isShowAccelerate" :isBaseData="isBaseData" @confirm="isShowAccelerate = false"
      @close="isShowAccelerate = false" />

    <!-- 购买喜欢数量弹窗 -->
    <purchaseModal :show="isShowModal" @close="isShowModal=false" @callback="isShowModal=false" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
// import { copy, isIOS, transferBytes } from '@/utils/tools'
import wxApi from '@/utils/wxAuth'
import { Toast } from 'vant'
import purchaseModal from '@/components/common/purchaseModal'
import AccelerateAduit from '@/components/dialog/accelerateAduit'
import Oss from '@/components/common/oss'
import UserInfo from '@/components/common/userInfo'
import { copy, isIOS, transferBytes, watermark } from '@/utils/tools'
import { UPLOAD_TYPE } from '@/config/constant'

const getRotate = () => {
  return import('@/utils/rotateImg.js')
}
export default {
  name: 'detailInfo',
  components: {
    AccelerateAduit,
    purchaseModal,
    Oss,
    UserInfo
  },
  data () {
    return {
      targetData: {
        wechatPicUrl: ''
      },
      isReporting: false,
      reportData: {
        description: '',
        imgData: []
      },
      tempImg: null,
      coverParams: { type: UPLOAD_TYPE.report },
      preImgArr: [],
      overlimit: false,
      purchaseItem: {},
      confirmPurchaseDialog: false,
      // 微信二维码弹窗
      isShowCodeDialog: false,
      // 错误状态提示弹窗
      errorStatus: 0,
      showErrorDialog: false,
      errorDialogContent: {
        message: '',
        confirmText: ''
      },
      // 购买 喜欢数量 弹窗
      isShowModal: false,
      // 是否显示加速审核弹窗
      isShowAccelerate: false,
      isBaseData: true,
      // 自动复制失败后的弹窗提示标识
      copyFail: false
    }
  },
  computed: {
    ...mapState({
      userData: 'userData',
      educationMap: 'educationMap',
      salaryMap: 'salaryMap',
      assetsMap: 'assetsMap',
      statusMap: 'statusMap',
      constellationMap: 'constellationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId',
      mId: 'mId'
    }),
    id () {
      return this.targetData.id
    },
    targetMid () {
      return this.$route.params.id
    },
    disableReport () {
      return this.reportData.description.length < 10 || !this.reportData.imgData.length
    },

    // 所在城市
    cityText (item) {
      return (item) => {
        if (!item.cityId) {
          return ''
        }
        if (parseInt(item.cityId) === 900000) return '现居' + (item.country + ' ' + item.state)
        return `现居${this.areaData['city_list'][item.cityId]}`
      }
    },
    nativeCityText (item) {
      return (item) => {
        if (!item.nativeCityId) {
          return ''
        }
        let nid = parseInt(item.nativeCityId)
        if (nid === 900000) {
          return item.nativeCountry + ' ' + item.nativeState + '人'
        } else {
          const provice = String(nid).substr(0,2) + '0000'
          return `${[110100, 120100, 310100, 500100].indexOf(nid) >= 0 ? '' : `${this.areaData['province_list'][provice]}`}${this.areaData['city_list'][item.nativeCityId]}人`
        }
      }
    },
    schoolText (item) {
      return (item) => `${this.educationMap[item.education]}${item.ifStudent ? '(在读)' : ''}`
    }
  },
  watch: {
    isReporting (val) {
      if (val) {
        this.$nextTick(() => {
          let $ref = this.$refs['reportInputContent']
          $ref && $ref.focus()
        })
      }
    },
    isShowCodeDialog (val) {
      this.copyFail = false
      if (val) {
        copy(`${this.mId}-${this.userData.cityId == '900000' ? this.userData.state : this.areaData['city_list'][this.userData.cityId]}-${this.userData.age}岁-${this.educationMap[this.userData.education]}-${this.userData.ifStudent ? '学生' : this.userData.job}`,
          this.$refs['code-con']).catch(() => {
            this.copyFail = true
          })
      }
    }
  },
  methods: {
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),
    // 计算出生肖
    calculater (year) {
      var arr1 = ['猴', '鸡', '狗', '猪', '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊']
      return /^\d{4}$/.test(year) ? `属${arr1[year % 12]}` : false
    },
    fetchInfo (notLoad) {
      if (!this.targetMid) {
        return
      }
      !notLoad && this.$root.openLoading()

      this.$http('/api/member/info', {
        targetMid: this.targetMid
      }, 'get').then(res => {
        !notLoad && this.$root.closeLoading()
        if (res.code === '0000') {
          const d = res.data

          this.targetData = d
          wxApi.configShare({
            title: 'Hello单身部落',
            // desc: 'ID号-学历-工作-年龄-城市',
            desc: `${d.mid}-${this.educationMap[d.education]}-${d.ifStudent ? '在读' : d.job}-${d.age}-${parseInt(d.cityId) === 900000 ? (d.country + ' ' + d.state) : this.areaData['city_list'][d.cityId]}`,
            link: location.href,
            imgUrl: `${d.headPicUrl}`
          })
        } else {
          this.$toast(res.data.msg)
        }
      }, err => {
        !notLoad && this.$root.closeLoading()
        this.$toast(err)
      })
    },
    transferPrice (val) {
      if (typeof val !== 'number') {
        return 0
      } else {
        return (val / 100).toFixed(1)
      }
    },
    /**
     * @description 是否登录状态
     * @returns { Boolean } 通过为true，否则false
     */
    checkLogin () {
      if (!this.userId) {
        // 未登录情况下
        this.errorStatus = 0
        this.errorDialogContent.message = '您当前未登录，请先登录'
        this.errorDialogContent.confirmText = '立即登录'
        this.showErrorDialog = true
        return false
      } else {
        return true
      }
    },
    /**
     * @description 基础资料审核状态判断
     * @returns { Boolean } 通过为true，否则false
     */
    checkBaseData () {
      if (!this.checkLogin()) return
      if (!parseInt(this.userData.firstBaseAuth)) {
        if (parseInt(this.userData.basedataAuth) === 1) {
          this.isBaseData = true
          this.isShowAccelerate = true
        } else if (parseInt(this.userData.basedataAuth) === 0) {
          this.errorStatus = 1
          this.errorDialogContent.message = '您当前未通过个人资料审核，请先通过个人资料审核'
          this.errorDialogContent.confirmText = '完善资料'
          this.showErrorDialog = true
        } if (parseInt(this.userData.basedataAuth) === 2) {
          this.errorStatus = 1
          this.errorDialogContent.message = '资料未通过审核，请修改重新提交'
          this.errorDialogContent.confirmText = '修改资料'
          this.showErrorDialog = true
        }
        return
      }
      return true
    },
    /**
     * @description 权限检查
     * @returns { Boolean } 通过为true，否则false
     */
    checkStatus () {
      if (!this.checkBaseData()) return
      // 权限判断
      let map = { identityAuth: '身份', academicAuth: '学历', workAuth: '工作' }

      for (let index = 0, keys = Object.keys(map); index < keys.length; index++) {
        let item = keys[index]; let label = map[item]; let option = this.userData[item]
        // 审核不通过状态提示优先级最高
        if (option === 2) {
          this.errorDialogContent.message = `使用本功能需要通过实名认证，您的认证未通过审核，请修改重新提交`
          this.errorDialogContent.confirmText = '提交证件'
          this.showErrorDialog = true
          return
        }
        if (option === 0) {
          this.errorStatus = 2
          this.errorDialogContent.message = '个人证件全部通过审核后才能索要微信，请立即提交个人证件'
          this.errorDialogContent.confirmText = '提交证件'
          this.showErrorDialog = true
          return
        }
        if (option === 1) {
          this.isBaseData = false
          this.isShowAccelerate = true
          return
        }
      }
      return true
    },
    switchReport () {
      if (!this.checkLogin()) return
      this.isReporting = !this.isReporting
    },
    switchFollow () {
      if (!this.checkLogin()) return
      this.$root.openLoading()
      this.$http(`/api/member/action`, {
        targetMemberId: this.id,
        fromMemberId: this.userId,
        toMemberId: this.id,
        type: this.targetData.follow ? 11 : 10
      }).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000') {
          this.targetData.follow = !this.targetData.follow
          let followCount = parseInt(this.userData.followCount)
          if (this.targetData.follow) {
            this.$toast('已成功关注该用户，可在“我的”页面中查看所有关注的人')
            followCount = followCount >= 0 ? followCount + 1 : 1
            this.updateUserData({
              followCount
            })
          } else {
            this.$toast('取消关注成功')
            followCount = followCount > 1 ? followCount - 1 : 0
            this.updateUserData({
              followCount
            })
          }
        } else {
          this.$toast(res.msg)
        }
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
      })
    },
    clickLike () {
      if (this.targetData.like) {
        return
      }
      if (!this.checkBaseData()) return
      this.$root.openLoading()
      this.$http('/api/member/action', {
        targetMemberId: this.id,
        fromMemberId: this.userId,
        toMemberId: this.id,
        type: 20
      }).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000') {
          // 更新喜欢的人数量
          let likeCount = parseInt(this.userData.likeCount)
          likeCount = likeCount >= 0 ? likeCount + 1 : 1
          this.updateUserData({
            likeCount
          })
          // 更新 “喜欢” 剩余个数
          let likeBalance = parseInt(this.userData.likeBalance)
          likeBalance = likeBalance >= 0 ? likeBalance - 1 : 1
          this.updateUserData({
            likeBalance
          })
          if (res.data['wechatPicUrl']) {
            this.targetData.wechatPicUrl = res.data.wechatPicUrl
            this.isShowCodeDialog = true
          } else {
            this.targetData.like = true
            this.$toast('ta已收到你的喜欢，若对方回点你喜欢，则自动公开彼此微信号')
          }
        } else if (res.code === '200001') {
          // 喜欢数量不足
          this.isShowModal = true
        } else {
          this.$toast('喜欢失败!')
        }
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
      })
    },
    /**
     * @description 购买微信前置判断
     */
    async getWebChatCode () {
      // this.confirmPurchaseDialog = true

      if (this.targetData.wechatPicUrl) {
        // 已经获取到微信，直接弹出微信二维码弹窗
        this.isShowCodeDialog = true
      } else if (!this.checkStatus()) { } else if (this.userData.overlimit) {
        this.overlimit = true
      } else {
        let { code, data, msg } = await this.$http('/api/member/product/list', { type: 2 }, 'get')
        if (!(code === '0000' && data)) return this.$toast(msg)
        // 打开确认购买弹窗
        this.purchaseItem = data[0]
        this.confirmPurchaseDialog = true
      }
    },
    /**
     * @description 购买微信
     */
    async purchase () {
      try {
        var fd = new FormData()
        fd.append('targetMemberId', this.id)
        fd.append('productId', this.purchaseItem.id)
        let { code, data, msg } = await this.$http('/api/member/purchase/transaction', fd)
        if (!(code === '0000' && data)) {
          return Toast(msg)
        }
        // 微信支付
        this.$http('/api/login/wx/jssdk/config/get', {
          pageUrl: location.href
        }, 'get').then(res => {
          if (res.code === '0000') {
            wxApi.init({
              appid: data.appId, // 正式测试号
              redirectUri: window.location.href
            }).wexinPay(data, res.data).then(res => {
              if (res.actionCode === 200) {
                // this.$toast('购买成功')
                let times = 0
                this.$root.openLoading()
                let timer = setInterval(() => {
                  // 遍历次数达到3秒上限或已经同步二维码，跳出遍历
                  if (times >= 6 || this.targetData.wechatPicUrl) {
                    clearInterval(timer)
                    this.$root.closeLoading()
                    if (!this.targetData.wechatPicUrl) {
                      this.$toast('购买成功, 但记录尚未同步，请稍后重试')
                    } else {
                      this.isShowCodeDialog = true
                    }
                  } else {
                    // fetchInfo 会同步数据
                    this.fetchInfo(true)
                    times++
                  }
                }, 500)
              } else {
                this.$toast('您取消了支付')
              }
            }).catch(e => {
              Toast('支付异常')
            })
          }
        }, err => {
          this.$root.closeLoading()
          //this.$toast(err)
        })
      } catch (error) {
        //Toast(error)
      }
    },
    handleErrorDialogClose () {
      this.showErrorDialog = false
      this.$nextTick(() => {
        switch (this.errorStatus) {
          case 0:
            this.$router.push({
              path: '/account.html',
              query: {
                redirect: this.$route.path
              }
            })
            break
          case 1:
            // 基础资料不通过。待审核状态，跳到个人主页，否则直接跳转到个人资料页
            if (parseInt(this.userData.basedataAuth) === 1) {
              this.$router.push({
                path: '/account.html'
              })
            } else {
              this.$router.push({
                path: '/baseInfo.html'
              })
            }
            break
          case 2:
            this.$router.push({
              path: '/account.html'
            })
            break
        }
      })
    },
    execCopy (text) {
      copy(text, this.$refs['code-con']).then(res => {
        this.$toast('复制成功')
      }, () => {
        this.$toast('复制失败')
      })
    },
    getPics () {
      let pics = []
      for (let i = 0; i < this.reportData.imgData.length; i++) {
        pics.push(this.reportData.imgData[i].id)
      }
      return pics
    },
    showPreview (index) {
      this.previewIndex = index
      this.isShowPreview = true
    },
    changePreview (index) {
      this.$refs['swipe'].swipeTo(index)
    },
    submitReport () {
      if (this.disableReport) return
      let fd = {}
      fd.targetMemberId = this.id
      fd.message = this.reportData.description
      fd.pics = this.getPics()
      this.$root.openLoading()
      this.$http('/api/member/report', fd).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000') {
          this.$toast('您已成功举报该用户，管理员会及时核实情况并处理，非常感谢！')
          setTimeout(() => {
            this.isReporting = false
          }, 1000)
        } else {
          this.$toast(res.msg)
        }
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
      })
    },
    selectImg (e) {
      this.tempImg = e.file
    },
    uploadSuccess (resUpload) {
      let imgReport = {}
      imgReport.id = resUpload.picId
      imgReport.url = resUpload.url
      this.reportData.imgData.push(imgReport)
      this.tempImg = null
    },
    deleteImg (index) {
      this.reportData.imgData.splice(index, 1)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchInfo()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.targetData = {}
    wxApi.configShare()
    next()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.detail-info-container {
  padding: 30px 40px 180px;
  .btns {
    position: fixed;
    bottom: 40px;
    left: 50%;
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    width: $clientWidth;
    transform: translateX(-50%);
    .btn {
      flex: 0 0 320px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
      border-radius: 4px;
    }
    .word {
      display: flex;
      align-items: center;
      font-size: 24px;
      line-height: 34px;
      font-weight: bold;
    }
    .remain-quanitity {
      margin-top: 4px;
      color: $mainColor;
      font-size: 20px;
      line-height: 28px;
    }
    .like-btn {
      flex-direction: column;
      color: $mainColor;
      border: 1px solid $mainColor;
      border-radius: 4px;
      background: #fff;
      &.liked {
        color: #9b9b9b;
        border: 1px solid #9b9b9b;
        .remain-quanitity {
          color: #9b9b9b;
        }
      }
    }
    .like-icon {
      margin-right: 10px;
      width: 30px;
    }
    .apply-btn {
      background: linear-gradient(90deg, #ffa2ca 0%, $mainColor 100%);
      .word {
        color: #fff;
      }
    }
    .apply-icon {
      margin-right: 10px;
      width: 40px;
    }
  }

  .confirm-purchase-content {
    padding: 30px 40px;
    .price-con {
      display: flex;
      align-items: flex-end;
      padding-bottom: 10px;
      border-bottom: 1px solid #dadada;
    }
    .cur-price {
      margin-right: 32px;
      color: $mainColor;
      font-size: 40px;
      line-height: 70px;
    }
    .origin-price {
      margin-bottom: 10px;
      color: #9b9b9b;
      font-size: 28px;
      line-height: 40px;
      text-decoration: line-through;
    }
    .unit {
      font-size: 28px;
    }
    ul.tipsList {
      padding-top: 15px;
      ol {
        line-height: 2;
        font-size: 25px !important;
      }
    }
    .strong {
      color: #4a4a4a;
    }
  }

  .target-code-dialog {
    padding: 40px 32px 30px;
    text-align: center;
    .target-name {
      margin-bottom: 24px;
      font-size: 32px;
      font-weight: bold;
    }
    .code {
      width: 260px;
      height: auto;
    }
    .tips {
      margin-top: 30px;
      color: #9b9ba1;
      font-size: 24px;
      line-height: 36px;
    }
  }

  .report-content {
    position: relative;
    width: $clientWidth;
    height: 100vh;
    background: #f7f7fa;
    .title-con {
      margin-bottom: 10px;
      padding: 32px 40px;
      display: flex;
      align-items: center;
      background: #fff;
      .btn {
        width: 28px;
      }
    }
    .title {
      margin-left: 20px;
      color: #38383c;
      font-size: 48px;
      line-height: 1;
    }
    .back-icon {
      display: block;
      width: 100%;
    }
    .textarea {
      display: block;
      width: 100%;
      padding: 24px 40px;
      min-height: 276px;
      font-size: 28px;
      line-height: 44px;
      resize: none;
    }
    .upload-box {
      margin-top: 10px;
      padding: 20px 40px;
      background: #fff;
    }
    .upload-title {
      margin-bottom: 40px;
      color: #9b9ba1;
      font-size: 32px;
      line-height: 44px;
    }
    .upload-content {
      display: flex;
      flex-wrap: wrap;
      margin-right: -40px;
      .upload-item {
        position: relative;
        flex: 0 0 196px;
        margin-right: 40px;
        height: 196px;
        &.select-item {
          border: 1px dashed #cacacd;
        }
      }
      .oss-item {
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .img-item {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .upload-btn {
        margin: 0 auto;
        display: block;
        height: 100%;
      }
      .delete-btn {
        position: absolute;
        right: 0;
        top: 0;
        padding: 10px;
        width: 40px;
        height: 40px;
        border-radius: 0 0 0 12px;
        background: rgba(54, 56, 55, 0.7);
      }
    }

    .commit-report {
      position: absolute;
      bottom: 70px;
      left: 50%;
      width: 590px;
      height: 100px;
      padding: 25px;
      color: #fff;
      font-size: 36px;
      line-height: 50px;
      text-align: center;
      border-radius: 50px;
      background: linear-gradient(305deg, $mainColor 0%, #ffbbd8 100%);
      transform: translateX(-50%);
      &.disable {
        background: linear-gradient(
          287deg,
          rgba(191, 191, 191, 1) 0%,
          rgba(231, 231, 231, 1) 100%
        );
      }
    }
  }
}
</style>
